import ActionWithPayload from 'moduleBase/reducers/types/ActionWithPayload';
import {
  APP_LOAD_MENU_MAIN_SUCCESS,
  MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE,
  MENU_MAIN_LOAD_SUB_MENU_COMPLETE,
  MENU_MAIN_SET_ACTIVE,
} from 'moduleBase/modules/menu/constants';
import { StateType } from 'moduleBase/modules/menu/types/StateType';
import { APP_INIT_RECEIVE } from 'moduleBase/constants';
import { AppInitReceivePayloadType } from 'moduleBase/actions/types/AppInitReceivePayloadType';
import { SetActivePayloadType } from 'moduleBase/modules/menu/actions/types/SetActivePayloadType';
import {
  LoadDynamicSubMenuCompletePayloadType,
} from 'moduleBaseMenu/actions/types/LoadDynamicSubMenuCompletePayloadType';
import { LoadSubMenuCompletePayloadType } from 'moduleBaseMenu/actions/types/LoadSubMenuCompletePayloadType';

const reducerMenu = (state: StateType = {}, action: ActionWithPayload): StateType => {
  switch (action.type) {
    case APP_INIT_RECEIVE: {
      const payload = action.payload as AppInitReceivePayloadType;
      return {
        ...state,
        menu: payload.menu,
      };
    }
    case APP_LOAD_MENU_MAIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case MENU_MAIN_SET_ACTIVE: {
      const payload = action.payload as SetActivePayloadType;
      return {
        ...state,
        activeId: payload.id,
      };
    }
    case MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE: {
      const payload = action.payload as LoadDynamicSubMenuCompletePayloadType;
      return {
        ...state,
        menu: {
          ...state.menu,
          blocks: state.menu.blocks.map((block) => {
            const blockNew = { ...block };
            blockNew.items = blockNew.items.map((item) => {
              if (item.id === payload.id) {
                return { ...item, items: [], dynamicItems: payload.items };
              }

              return item;
            });
            return blockNew;
          }),
        },
      };
    }
    case MENU_MAIN_LOAD_SUB_MENU_COMPLETE: {
      const payload = action.payload as LoadSubMenuCompletePayloadType;
      return {
        ...state,
        menu: {
          ...state.menu,
          blocks: state.menu.blocks.map((block) => {
            const blockNew = { ...block };
            blockNew.items = blockNew.items.map((item) => {
              if (item.id === payload.id) {
                return { ...item, items: payload.items };
              }

              return item;
            });
            return blockNew;
          }),
        },
      };
    }
    default:
      return state;
  }
};

export { reducerMenu };
